<section class="info-card info-card--primary">
    <h2 class="info-card__title">{{ 'app.components.courseInfo.title' | translate }}</h2>

    <div class="stats-row">
      <div class="stats-chip" *ngFor="let stat of course()?.tags ?? []">
        {{ stat }}
      </div>
    </div>

    @if (showJoinButton()) {
      <app-cta-button
        class="info-card__join-btn"
        variant="white"
        size="large"
        [loading]="isJoinPending()"
        (clicked)="joinCourse.emit()"
      >
        <span cta-prefix aria-hidden="true">
          <img src="/public/svgs/play-circle.svg" alt="Play">
        </span>
        <span cta-label>{{ 'app.components.courseDetail.startCourse' | translate }}</span>
      </app-cta-button>
    }
    @if (showCancelButton()) {
      <app-cta-button
        class="info-card__cancel-btn"
        variant="white"
        size="large"
        [loading]="isLeavePending()"
        (clicked)="leaveCourse.emit()"
      >
        <span cta-label>{{ 'app.components.courseDetail.cancelCourse' | translate }}</span>
      </app-cta-button>
    }
  </section>